import Nullstack from 'nullstack';
export default function IconBrandWix({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-wix",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 9l1.5 6l1.379 -5.515a0.64 .64 0 0 1 1.242 0l1.379 5.515l1.5 -6"
  }), "   ", Nullstack.element("path", {
    d: "M13 11.5v3.5"
  }), "   ", Nullstack.element("path", {
    d: "M16 9l5 6"
  }), "   ", Nullstack.element("path", {
    d: "M21 9l-5 6"
  }), "   ", Nullstack.element("path", {
    d: "M13 9h.01"
  }), " ");
}